import { render } from "./NotFound.vue?vue&type=template&id=34e4e1a3"
import script from "./NotFound.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./NotFound.vue?vue&type=script&charset=utf-8&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__